import { useCallback, useEffect, useState } from 'react';
import { platformApi } from '@/api/platform.api';
import type { ErpModule, OrganizationModuleDto } from '@/api/platform.api';

export function useOrganizationModules() {
  const [modules, setModules] = useState<OrganizationModuleDto[]>([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const list = await platformApi.listModules();
      setModules(list);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  const isEnabled = useCallback(
    (module: ErpModule) => modules.find((m) => m.module === module)?.enabled ?? false,
    [modules],
  );

  return { modules, loading, refresh, isEnabled };
}
